import React from "react";

const LogoutIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.04004 11.32H19'
        stroke='white'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.5801 7.89999L19.0001 11.32L15.5801 14.74'
        stroke='white'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.91 1.23999H3.25C1.99 1.23999 1 2.22999 1 3.39999V19.15C1 20.41 1.99 21.4 3.25 21.4H9.91'
        stroke='white'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LogoutIcon;
